var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110.491,
    height: 110.744,
    viewBox: "0 0 110.491 110.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2223",
    "data-name": "Group 2223",
    transform: "translate(-311.955 -1766.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2222",
    "data-name": "Group 2222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3597",
    "data-name": "Path 3597",
    d: "M360.729,1766.863c36.189,2.846,53.942,43.12,35.684,71.25,48.177,39.247,21.026,58.34-13.392,13.808C307.77,1888.942,280.116,1768.987,360.729,1766.863Zm-3.017,87.4c56.8-3.331,52.346-81.258-.1-82.505C300.8,1775.1,305.274,1853.013,357.712,1854.262Zm37.267,2.8c24.177,29.234,32.758,13.751,6.747-6.745Zm-3.656-3.715,6.567-6.571-4.169-4.188-6.645,6.526Z",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3598",
    "data-name": "Path 3598",
    d: "M357.714,1781.05c-44.035,2.517-40.562,62.7-.1,63.938C401.617,1842.461,398.231,1782.247,357.714,1781.05Zm-.057,58.755c-37.245-2.342-33.431-52.765,0-53.587v-.5l.011.5C394.917,1788.554,391.1,1838.995,357.657,1839.805Z",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3599",
    "data-name": "Path 3599",
    d: "M377.443,1809.047c2.2-7.415-17.826-23.815-17.833-12.078C375.676,1797.517,372.02,1818.894,377.443,1809.047Z",
    fill: "#ef7b13"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.d3475b5a4e3e1241c4787f30ff29288f.svg";
export { ForwardRef as ReactComponent };